import { useMutation } from 'react-query'
import { api } from '../../../api'

const projectToFile = async (id: number) => {
  const response = await api.patch(`/projects/${id}/file`)
  return response.data
}

export const useProjectToFileMutation = () => {
  return useMutation({
    mutationFn (id: number) {
      return projectToFile(id)
    }
  })
}
